import { ReactNode } from 'react';

import { UserPlan } from '../../types';

type TarifDescription = {
  price: {
    yearly: number;
    monthly: number;
  };
  features: ReactNode[];
};

// TODO: вынести на бэк
export const tarifsDescription: Record<UserPlan, TarifDescription> = {
  free: {
    price: {
      yearly: 0,
      monthly: 0,
    },
    features: [
      'Доступны все игры',
      'Полная кастомизация игр',
      '✘ Доступны не все интеграции',
      '✘ Нельзя убрать брендирование',
    ],
  },
  basic: {
    price: {
      yearly: 690,
      monthly: 990,
    },
    features: [
      'Доступны все игры',
      'Полная кастомизация игр',
      '✔ Доступны все интеграции',
      '✘ Нельзя убрать брендирование',
    ],
  },
  business: {
    price: {
      yearly: 1390,
      monthly: 1790,
    },
    features: [
      'Доступны все игры',
      'Полная кастомизация игр',
      '✔ Доступны все интеграции',
      '✔ Можно убрать брендирование',
    ],
  },
  premium: {
    price: {
      yearly: 1990,
      monthly: 2990,
    },
    features: [
      'Доступны все игры',
      'Полная кастомизация игр',
      '✔ Доступны все интеграции',
      '✔ Можно убрать брендирование',
    ],
  },
};
